import React from 'react';
import PropTypes from 'prop-types';
import ContentText from './ContentText';
import { converter } from '../../helpers/converter';

const ContentWrapper = ({
  children,
  className,
  styleContent,
  translations,
  registerForm,
  redirectToLogin,
}) => (
  <div className={`promos promos-wrapper ${className}`}>
    <div className="promos promos-container">
      <div className="promos promos-content-wrapper">
        <div className="promos promos-content" style={styleContent}>
          {children}
        </div>
        {registerForm && (
          <div className="greyBackground">
            <ContentText>
              {converter.convertApaUnicode(
                translations,
                'ip_telmex_login_label',
                '¿Ya tienes una cuenta de Claro video?',
              )}
            </ContentText>
            <div className="col-sm-10 col-sm-offset-1 xs-mt-20 xs-mb-20">
              <button
                className="btn btn-block btn-login-iptelmex"
                type="button"
                onClick={redirectToLogin}
              >
                {converter.convertApaUnicode(
                  translations,
                  'ip_telmex_login_link',
                  'INICIA SESIÓN',
                )}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  </div>
);

ContentWrapper.propTypes = {
  styleContent: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.node,
  translations: PropTypes.object,
  registerForm: PropTypes.bool,
};

ContentWrapper.defaultProps = {
  styleContent: {},
  className: '',
};

export default ContentWrapper;
